import styled from '@emotion/styled/macro';
import { Banner } from '../base/banner/banner';
import { UnderlineTabs } from '../base/underline-tabs/underline-tabs';
import { Variables } from '../base/variables';

const V = Variables.ThemeLight;

/** Same page frame as the Payers redesign, so the two read as one console. Sizes follow the Roster mockup. */
export const Wrapper = styled.section`
    padding: 52px 56px;
`;

export const PageBanner = styled(Banner)`
    margin-bottom: 20px;
`;

export const Header = styled.header`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 20px;
`;

export const TitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

/**
 * Separate properties, not the `font:` shorthand. `font: 600 22px/1.3 var(--font-sans, inherit)`
 * is invalid once the fallback resolves — `inherit` cannot be a family inside the shorthand —
 * and the browser drops the whole declaration, so the heading renders at body size (PP-21).
 */
export const Title = styled.h1`
    margin: 0;
    font-size: 26px;
    font-weight: 600;
    line-height: 1.2;
    color: ${V.TextStrong};
`;

export const Subtitle = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: ${V.TextMild};
`;

export const HeaderActions = styled.div`
    display: flex;
    flex: none;
    align-items: center;
    gap: 8px;
`;

export const ButtonContent = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
`;

export const Tabs = styled(UnderlineTabs)`
    margin-bottom: 16px;
` as typeof UnderlineTabs;

export const TypeRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 14px;
`;

export const TypeLabel = styled.span`
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${V.TextXMild};
`;

/** The white card holding the table. */
export const Panel = styled.div`
    background: ${V.Background3};
    border: 1px solid ${V.Border1};
    border-radius: 8px;
    overflow: hidden;
`;
